/**
 * Runtime environment access. Vite exposes only `VITE_*` env vars to the client.
 * In dev all backend calls go through Vite proxy → same origin, no CORS.
 * In production the bundle is served by the Go backend itself, also same origin.
 *
 * E01.12 — added optional Sentry / app-version vars. We stop short of pulling
 * in zod just for this (3 string fields, no nested shapes); a small inline
 * sanity check covers the only mistake we care about (a non-string DSN).
 */

function readOptionalString(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

const sentryDsn = readOptionalString(import.meta.env.VITE_SENTRY_DSN)
const appVersion = readOptionalString(import.meta.env.VITE_APP_VERSION)

export const env = {
  // Empty string means "current origin" — the only value we should ever ship.
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
  /**
   * Sentry DSN — D-05. Empty until the standalone frontend Sentry project is
   * provisioned. When `undefined`, `Sentry.init` is invoked with
   * `enabled: false` and every capture call becomes a no-op.
   */
  sentryDsn,
  /**
   * Build version string injected by the deploy pipeline (E11). Defaults to
   * `'dev'` for local builds — used for both Sentry release tagging and the
   * AutoUpdate cache-bust query string.
   */
  appVersion: appVersion ?? 'dev',
} as const
